/**
 * Check if a scope value represents "all access"
 * Handles both the new ["*"] convention and the deprecated null convention
 */
export function isAllAccess(scopeValue) {
    if (scopeValue === null || scopeValue === undefined)
        return true;
    return scopeValue.length === 1 && scopeValue[0] === '*';
}
/**
 * The wildcard value representing "all access" in scope arrays
 */
export const SCOPE_ALL_ACCESS = '*';
